import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private http = inject(HttpClient);

  public changelogAragorn(): Promise<string> {
    return firstValueFrom(this.http.get('assets/CHANGELOG.md', { responseType: 'text' }));
  }

  public changelogSauron(): Promise<any> {
    return firstValueFrom(this.http.get(`${environment.app.apiUrl}/system/changelog`, { responseType: 'json' }));
  }
}
